var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCaretRightCircle = function SvgCaretRightCircle(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.148,407.505a13.5,13.5,0,1,1-13.5,13.5A13.516,13.516,0,0,1,298.148,407.505Zm0,26a12.5,12.5,0,1,0-12.5-12.5A12.515,12.515,0,0,0,298.148,433.505Z",
    transform: "translate(-284.648 -407.505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.049,415.112a.537.537,0,0,1,.754,0l5.449,5.45a.6.6,0,0,1,0,.8l-5.454,5.455a.537.537,0,0,1-.758,0,.541.541,0,0,1,0-.754l5.1-5.094-5.1-5.1A.536.536,0,0,1,295.049,415.112Z",
    transform: "translate(-284.649 -407.505)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretRightCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-right-circle.cc1c6060.svg";
export { ForwardRef as ReactComponent };